import { Component, OnInit } from '@angular/core';

import { HomrDataService } from '@shared/homr/data-access';

const  IMAGE_LOCATION = 'https://images.dickssportinggoods.com/marketing/';
@Component({
	selector: 'my-account-templates-shop-by-category',
	templateUrl: './shop-by-category.component.html',
	styleUrls: ['./shop-by-category.component.scss']
})
export class ShopByCategoryComponent implements OnInit {
  	categories =  [];

  	constructor(private homrDataService: HomrDataService) { }

  	ngOnInit(): void {
  		this.shopByCategoryRequest$();
  	}

  	private shopByCategoryRequest$() {
  		return this.homrDataService.getData$('header', 2, 'default')
  			.subscribe(
  				(response) => {
  					this.categories = (response?.content?.Taxonomy2 ?? [])
  						.map(category => ({
  								title : category.title,
  								link: category.link,
  								imgUrl: this.getCategoryImageUrl(category)

  							}))
  						.filter(category => category.imgUrl?.length > 0);
  					return response;
  				});
  	}

  	private getCategoryImageUrl(category): string {
  		if(!category.flyoutImage || category.flyoutImage.length === 0){
  			return null;
  		}
  		return IMAGE_LOCATION + category.flyoutImage[0].imageUpload;
  	}

}


